import ProjectDocument from "../../model/document/ProjectDocument";
import { UUID } from "../../utils/typeDefinitions";
import ApiDocumentProvider from "./ApiDocumentProvider";
import Document from "../../model/document/Document";
import IBimVisualizerApiProvider from "../bimVisualizerApi/IBimVisualizerApiProvider";
import SceneObjectData from "../../model/sceneObjectData/SceneObjectData";
import IContextDocument from "../../model/document/IContextDocument";

abstract class ApiProjectDocumentProvider extends ApiDocumentProvider {
    protected projectUuid: UUID;
    protected apiProvider: IBimVisualizerApiProvider;
    
    constructor(projectId: UUID, apiProvider: IBimVisualizerApiProvider) {
        super(apiProvider);
        this.projectUuid = projectId;
        this.apiProvider = apiProvider;
    }
    
    async getDocuments(): Promise<Document[]> {
        return await this.apiProvider.getProjectDocuments(this.projectUuid, this.getEntityId());
    }

    async saveDocument(document: ProjectDocument): Promise<boolean> {
        throw new Error("Method not implemented.");
        /* const response = await this.apiProvider.addDocument(document);
        return response !== null; */
    }
    
    // Create initial empty document
    abstract createInitialDocument(): Promise<IContextDocument>;

    // Get the ID of the entity (apartment, storey, etc.) associated with this document provider
    abstract getEntityId(): UUID;

    // Add scene object to document in the backend
    async addSceneObject(documentUuid: UUID, sceneObjectData: SceneObjectData): Promise<SceneObjectData | null> {
        const response = await this.apiProvider.addSceneObject(documentUuid, sceneObjectData);
        return response;
    }

    // Remove scene object from document in the backend
    async removeSceneObject(sceneObjectUuid: UUID): Promise<boolean> {
        const response = await this.apiProvider.removeSceneObject(sceneObjectUuid);
        return response;
    }
}

export default ApiProjectDocumentProvider;